import React from "react";
import logo1 from "../../assets/ClientsLogos/beauharnois_transparent.png";
import logo2 from "../../assets/ClientsLogos/valleyfield_transparent.png";
import logo3 from "../../assets/ClientsLogos/af_dix30.png";
import logo4 from "../../assets/ClientsLogos/af_chateauguay.png";
import { useTranslation } from "react-i18next";

export default function OurClients() {
  const logos = [logo1, logo2, logo3, logo4];
  const { t } = useTranslation();

  return (
    <div
      className="d-flex flex-column align-items-center px-3 py-4"
      style={{ gap: "30px" }}
    >
      {/* Title */}
      <div className="text-center fw-bold">
        <span className="d-none d-md-block" style={{ fontSize: "75px" }}>
          {t("homePage.ourClients.title")}
        </span>
        <span className="d-md-none" style={{ fontSize: "42px" }}>
          {t("homePage.ourClients.title")}
        </span>
      </div>

      {/* Carousel */}
      <div className="carousel-track-wrapper">
        <div className="carousel-track">
          {[...logos, ...logos].map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Client ${index + 1}`}
              className="client-logo"
            />
          ))}
        </div>
      </div>

      {/* Inline CSS for responsive logo sizing and carousel animation */}
      <style jsx>{`
        .carousel-track-wrapper {
          width: 100%;
          overflow: hidden;
        }

        .carousel-track {
          display: flex;
          align-items: center;
          gap: 80px;
          width: max-content;
          animation: scroll 25s linear infinite;
        }

        .carousel-track-wrapper:hover .carousel-track {
          animation-play-state: paused;
        }

        @keyframes scroll {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }

        .client-logo {
          max-height: 400px;
          object-fit: contain;
        }

        @media (max-width: 768px) {
          .client-logo {
            max-height: 150px;
          }
        }
      `}</style>
    </div>
  );
}